import { render, staticRenderFns } from "./WorkFrontABMComponent.vue?vue&type=template&id=c4c285e6&scoped=true"
import script from "./WorkFrontABMComponent.js?vue&type=script&lang=js&external"
export * from "./WorkFrontABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./WorkFrontABMComponent.vue?vue&type=style&index=0&id=c4c285e6&prod&scoped=true&lang=scss"
import style1 from "./WorkFrontABMComponent.vue?vue&type=style&index=1&id=c4c285e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c285e6",
  null
  
)

export default component.exports